import script from "./AdminNewsListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminNewsListPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminNewsListPage.vue?vue&type=style&index=0&id=582fc55e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-582fc55e"]])

export default __exports__